import { Box, Container, Divider, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import Header from '../../components/dashboard/Header'
import { useExam } from '../../hooks/useExam'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../store'
import { TUser } from '../../shared/types/user.type'
import { resetCheckedExam, setAllKeyLayouts, setCategories, setData } from '../../store/reducers/comparaison.reducer'
import { TgroupKeyParam, getAllLayoutKeysFromData, groupKeyParamsByCategories } from '../../shared/utils/comparaison'
import { toast } from 'react-toastify'
import { t } from 'i18next'
import ComparaisonSection from '../../components/comparaison/ComparaisonSection'
import { TtrainingKeyParameter } from '../../shared/types/trainingKeyParameter.type'
import { useSearchParams } from 'react-router-dom'
import { isEmpty, toNumber, uniqBy } from 'lodash'
import { useAuth } from '../../hooks/useAuth'
import { TKeyParamLayout } from '../../shared/types/exam.type'
import { TkeyParamLayout } from '../../shared/types/computedKeyParam.type'
import LightThemePage from '../../components/layout/LightThemePage'
import palette from '../../theme/palette'
import AnimatedLogo from '../../components/global/AnimatedLogo'
import useHubspotTracking from '../../hooks/useHubspotTracking'

function ExternalComparaison() {
    const user = useSelector<RootState>(state => state.user.user) as TUser | null
    const { compare } = useExam(false, user?.['@id'])
    const dispatch = useDispatch()
    const categories = useSelector<RootState>(state => state.comparaison.categories) as TgroupKeyParam[]
    const data = useSelector<RootState>(state => state.comparaison.data) as TtrainingKeyParameter
    let [searchParams, setSearchParams] = useSearchParams();
    const { setToken, getUser, isUserFetching, getKeyParamsLayout, layoutKeys } = useAuth()
    const [customLayouts, setCustomLayouts] = useState<TKeyParamLayout[]>([])
   
   
   
    //To hide chat banner in this page
    useHubspotTracking()


    //query params
    const TOKEN = searchParams.get('token')
    const EXAMS = searchParams.get('exams')
    const INSIGHT_PARAMS = searchParams.get('insight-parameters')

    //effects


    useEffect(() => {
        if (user) {
            loadUserInfos()
        }

    }, [user?.id, EXAMS, INSIGHT_PARAMS, customLayouts.length])


    useEffect(() => {
        //if token defined set 
        if (TOKEN) {
            setToken(TOKEN)
            getUser()
        }
    }, [TOKEN])


    useEffect(() => {
        setCustomLayouts(layoutKeys)
    }, [layoutKeys])



    //fns

    const loadUserInfos = async () => {
        try {
            await getKeyParamsLayout.mutateAsync()
            dispatch(resetCheckedExam())
            compareTrainings(true)

        } catch (error) {
            console.log('error while fetching keys', error)
        }
    }

    const getUrlStrfromIDS = (ids: number[]) => {
        let str: string[] = []
        ids.forEach(id => {
            str.push(`${encodeURIComponent('training[]')}=${encodeURIComponent(id)}`)
        })

        return str.join('&')
    }





    const compareTrainings = (useIds: boolean = true) => {

        if (!EXAMS) return

        console.log({ EXAMS });

        let ids: number[] = EXAMS.split(',').map(e => toNumber(e))

        console.log({ ids });


        compare.mutateAsync({ ids: useIds ? getUrlStrfromIDS(ids) : '', allKeyParam: true })
            .then(({ data }) => {

                dispatch(resetCheckedExam())

                let layoutKeys = getAllLayoutKeysFromData(data) ?? []

                dispatch(setAllKeyLayouts(layoutKeys))

                let groupedKeyParams = []



                if (INSIGHT_PARAMS) {
                    let key_layout_from_query = handleInsightParamsQuery(layoutKeys)

                    groupedKeyParams = isEmpty(key_layout_from_query) ? groupKeyParamsByCategories(customLayouts) : key_layout_from_query
                } else {
                    groupedKeyParams = groupKeyParamsByCategories(customLayouts)
                }

                dispatch(setCategories(groupedKeyParams))
                dispatch(setData(data))
            }).catch(err => {
                console.log({ err });
                toast(t('error:generic'), { type: "error" })
            })

    }

    const handleInsightParamsQuery = (layoutKeys: TkeyParamLayout[]) => {

        //Split insight param in query by , to array
        let splitted_insight_param = INSIGHT_PARAMS?.split(',')

        if (!isEmpty(splitted_insight_param)) {
            //we get param layout by insight param id

            let mappedLayout = splitted_insight_param?.map(sp => layoutKeys.find(e => e.insight_parameter['@id'] === sp)) ?? []


            return uniqBy(mappedLayout.map(l => ({
                key: l?.insight_parameter?.name,
                title: l?.insight_parameter?.name_translated,
                detail: l?.insight_parameter?.details_translated,
            })), 'key')
        }
        return []

    }

    return (
        <LightThemePage>
            <Container maxWidth='lg' sx={{ mt: 2 }}>
                <Header text='navbar:comparison'>
                </Header>

                <Divider sx={{ my: 2 }}></Divider>

                <ComparaisonSection
                    printable={true}
                    canChangeParam={false}
                    showExplenation={false}
                    compare={() => compareTrainings()} data={data} categories={categories} loading={compare.isLoading || isUserFetching}></ComparaisonSection>

                <footer style={{ display: 'flex', justifyContent: 'end' }}>
                    <Typography variant='subtitle2' >
                        {t('pdfFooterArioneo')}
                    </Typography>
                </footer>
            </Container>
        </LightThemePage>
    )
}

export default ExternalComparaison